// Data from excel sheet
export const SET_EXCEL_DATA = 'SET_EXCEL_DATA'

export const SET_CAMPAIGN_DATA = 'SET_CAMPAIGN_DATA'
export const UPDATE_CAMPAIGN_DATA = 'UPDATE_CAMPAIGN_DATA'
export const REINITIALIZE_CAMPAIGN_DATA = 'REINITIALIZE_CAMPAIGN_DATA'

export const UPDATE_EXCEL_USERS = 'UPDATE_EXCEL_USERS'
export const UPDATE_OVERWRITE_NAME = 'UPDATE_OVERWRITE_NAME'
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
export const UPDATE_FILTERS = 'UPDATE_FILTERS'
export const UPDATE_CHANNEL = 'UPDATE_CHANNEL'
export const UPDATE_ADVANCED_FILTERS = 'UPDATE_ADVANCED_FILTERS'

export const MARKETING_GET_ALL_TEMPLATES_REQUEST = 'MARKETING_GET_ALL_TEMPLATES_REQUEST'
export const MARKETING_GET_ALL_TEMPLATES_SUCCESS = 'MARKETING_GET_ALL_TEMPLATES_SUCCESS'
export const MARKETING_GET_ALL_TEMPLATES_FAILURE = 'MARKETING_GET_ALL_TEMPLATES_FAILURE'

export const MARKETING_GET_TEMPLATE_REQUEST = 'MARKETING_GET_TEMPLATE_REQUEST'
export const MARKETING_GET_TEMPLATE_SUCCESS = 'MARKETING_GET_TEMPLATE_SUCCESS'
export const MARKETING_GET_TEMPLATE_FAILURE = 'MARKETING_GET_TEMPLATE_FAILURE'

export const MARKETING_CREATE_TEMPLATE_REQUEST = 'MARKETING_CREATE_TEMPLATE_REQUEST'
export const MARKETING_CREATE_TEMPLATE_SUCCESS = 'MARKETING_CREATE_TEMPLATE_SUCCESS'
export const MARKETING_CREATE_TEMPLATE_FAILURE = 'MARKETING_CREATE_TEMPLATE_FAILURE'

export const MARKETING_UPDATE_TEMPLATE_REQUEST = 'MARKETING_UPDATE_TEMPLATE_REQUEST'
export const MARKETING_UPDATE_TEMPLATE_SUCCESS = 'MARKETING_UPDATE_TEMPLATE_SUCCESS'
export const MARKETING_UPDATE_TEMPLATE_FAILURE = 'MARKETING_UPDATE_TEMPLATE_FAILURE'

export const MARKETING_DELETE_TEMPLATE_REQUEST = 'MARKETING_DELETE_TEMPLATE_REQUEST'
export const MARKETING_DELETE_TEMPLATE_SUCCESS = 'MARKETING_DELETE_TEMPLATE_SUCCESS'
export const MARKETING_DELETE_TEMPLATE_FAILURE = 'MARKETING_DELETE_TEMPLATE_FAILURE'

export const MARKETING_PUBLISH_TEMPLATE_REQUEST = 'MARKETING_PUBLISH_TEMPLATE_REQUEST'
export const MARKETING_PUBLISH_TEMPLATE_SUCCESS = 'MARKETING_PUBLISH_TEMPLATE_SUCCESS'

export const MARKETING_GET_TEMPLATE_VARIABLES_REQUEST = 'MARKETING_GET_TEMPLATE_VARIABLES_REQUEST'
export const MARKETING_GET_TEMPLATE_VARIABLES_SUCCESS = 'MARKETING_GET_TEMPLATE_VARIABLES_SUCCESS'
export const MARKETING_GET_TEMPLATE_VARIABLES_FAILURE = 'MARKETING_GET_TEMPLATE_VARIABLES_FAILURE'

export const MARKETING_GET_CAMPAIGNS = 'MARKETING_GET_CAMPAIGNS'
export const MARKETING_CAMPAIGNS_UPDATE_FILTERS = 'MARKETING_CAMPAIGNS_UPDATE_FILTERS'
export const MARKETING_GET_CAMPAIGN = 'MARKETING_GET_CAMPAIGN'
